import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import ProcessedResult from './report-generation-module/ProcessedResult';
import DownloadPdf from './report-generation-module/DownloadPdf';
import { FullscreenProvider } from './context/FullScreenContext';
import ProtectedRoute from './protected-route/ProtectedRoute';
import NoAccess from './protected-route/NoAccess';
// import FileProvider  from './context/Context';
import { FileProvider } from "./context/Context"; // path as per your project
import FormDetails from '../src/audit-creation-module/FormDetails';
import StartInspectionRetake
  from './camera-module/instructions-module/StartInspectionRetake';
import AuditDesc from './intro-module/AuditDesc';
import StartInspection
  from './camera-module/instructions-module/StartInspection';
import VideoInstruction
  from './video-module/instructions-module/VideoInstruction';
// import ViewAudit from "./view-audit/ViewAudit";
import Inspection from './audit-creation-module/Inspection';
// import CameraModuleUpdated from "./components/imageCategories/UpdatedCameraCopy";
import Login from './login-module/login';
import Signup from './login-module/signup';
import CameraModule from './camera-module/Camera';
import ClaimNewAudit from './audit-creation-module/ClaimNewAudit';
import NextAudit from './camera-module/NextAudit';
import NextCameraModule from './camera-module/NextCameraModule';
import CameraModule2 from './camera-module/Camera2';
import CameraModuleRetake from './camera-module/CameraRetake';
import ImageAnalyzer from './components/TestCams/ImageTester';
import ImageUploadPopUp from './camera-module/ImageUploadPopUp';
import SuccessComponent from './audit-completion-module/SuccessComponent';
import SuccessfulComponent from './audit-completion-module/SuccessfulComponent';
import Permission from './camera-module/location-camera-permission/Permission';
import Permission2 from './camera-module/location-camera-permission/Permission2';
import FormUpload from './DocumentUploadScreen';
import PermissionRetake from './camera-module/location-camera-permission/PermissionRetake';
import VideoRecorder from './video-module/VideoModule';
import Processing from './audit-completion-module/Processing';
import ProcessingRetake from './audit-completion-module/ProcessingRetake';
import TestCache from './components/TestCams/TestCache';
import InternetSignal from './components/TestCams/InternetSignal';
import InspectionMethod
  from './audit-creation-module/inspection-mode/InspectionMethod';
import InspectionMethod2
  from './audit-creation-module/inspection-mode/InspectionMethod2';
import ModePrRoute from './protected-route/ModePrRoute'
import PermissionVideo
  from './video-module/location-camera-audio-permission/Permission';
import StartInspectionVideo
  from './video-module/instructions-module/StartInspection';
import VideoTimer from './video-module/video-timer/VideoTimer';
import AuditDeathDesc from './intro-module/AuditDeathDesc';
import DocumentUploadScreen from './DocumentUploadScreen';
import ProcessingVideo
  from './audit-completion-module/video-module-completion/Processing';
import ShareAuditOptions from './components/TestCams/ShareAuditOptions';
import ShareOptions from './components/TestCams/ShareAuditOptions';
import WebcamVideo from './components/TestCams/ImageTester';
import Photo_Video_Instruction
  from './camera-module/photo_video_instruction/Photo_Video_Instruction';
import SpeedTest from './components/TestCams/NetworkCheck';
import DynamicResolutionWebcam from './components/TestCams/NetworkCheck';
import PermissionHybrid
  from './hybrid-mode-module/location-camera-permission/Permission';
import StartInspectionHybrid
  from './hybrid-mode-module/instructions-module/StartInspection';
import CameraModuleHybrid from './hybrid-mode-module/Camera';
import LandscapeMode from './camera-module/LandscapeMode';
import ProcessingHybrid
  from './audit-completion-module/hybrid-module-completion/Processing';
import AuditCreation from './audit-creation-module/AuditCreation';
import ModeProtectedRoute from './protected-route/ModeProtectedRoute';
import RetakeStatusGuard from './protected-route/RetakeStatusGuard'
import Introduction from './intro-module/Introduction'
import AuditList from './intro-module/AuditList'
import AuditDescription from './intro-module/AuditDescription';
import AuditDescription2 from './intro-module/AuditDescription2';
import PrefDeathForm from './audit-creation-module/PrefDeathForm';

import UserType from './nativeHelperComponents/userType';
import InputLink from './nativeHelperComponents/pasteLinkComponent';
import ForgotPassword from './login-module/ForgotPassword';
import ResetPassword from './login-module/ResetPassword';
import PasswordResetForm from './login-module/NewPassword';
import WebcamCapture from './test_CAM/a55issue';
import TermAndConditions from './term-and-condition-module/TermAndConditions';
import TermAndConditions2 from './term-and-condition-module/TermAndConditions2';
// import ClaimDetailsForm from './audit-creation-module/claimDetailsForm';
import UploadDoc from './audit-creation-module/UploadDoc';
// import LocationPermission from "./instructions-module/LocationPermission";
function App() {
  console.log("Providers:", typeof FullscreenProvider, typeof FileProvider);
   const dbg = (name, v) => {
  const tag =
    typeof v === "function"
      ? "function"
      : v && v.$$typeof
      ? `react-object(${String(v.$$typeof)})`
      : typeof v;

  console.log(`${name}:`, tag, v);
};

dbg("RetakeStatusGuard", RetakeStatusGuard);
dbg("ModeProtectedRoute", ModeProtectedRoute);
dbg("ModePrRoute", ModePrRoute);
dbg("ProtectedRoute", ProtectedRoute);
dbg("FileProvider", FileProvider);
dbg("FullscreenProvider", FullscreenProvider);
dbg("CameraModule2", CameraModule2);
dbg("NextCameraModule", NextCameraModule);
 const checkComp = (name, C) => {
  const ok =
    typeof C === "function" ||
    (C && typeof C === "object" && C.$$typeof); // memo/forwardRef

  if (!ok) {
    console.error("❌ BAD COMPONENT:", name);
    console.log("   value:", C);
    console.log("   typeof:", typeof C);
    console.log("   has default export?:", C?.default);
  }
};

// CHECK ONLY the components that appear in Routes first:
checkComp("Login", Login);
checkComp("Signup", Signup);
checkComp("AuditList", AuditList);
checkComp("UploadDoc", UploadDoc);
checkComp("InspectionMethod", InspectionMethod);
checkComp("InspectionMethod2", InspectionMethod2);
checkComp("Permission", Permission);
checkComp("Permission2", Permission2);
checkComp("PermissionVideo", PermissionVideo);
checkComp("PermissionHybrid", PermissionHybrid);
checkComp("StartInspection", StartInspection);
checkComp("StartInspectionVideo", StartInspectionVideo);
checkComp("StartInspectionHybrid", StartInspectionHybrid);
checkComp("ModeProtectedRoute", ModeProtectedRoute);
checkComp("ModePrRoute", ModePrRoute);
checkComp("ProtectedRoute", ProtectedRoute);
checkComp("RetakeStatusGuard", RetakeStatusGuard);




  return (
    <Router>
      <FullscreenProvider>
        <FileProvider>

          <Routes>
            {/* generic routes for video & photo mode */}
            <Route path="/" element={<Login />} />
            <Route path="/userType" element={<UserType />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/auditList" element={<AuditList />} />
            <Route path="/upload-documents/:audit_id" element={<UploadDoc />} />
            <Route path="/landscapeMode/:audit_id" element={<LandscapeMode />} />
            <Route path="/ClaimNewAudit" element={<ClaimNewAudit />} />
            <Route path="/auditDescription" element={<AuditDescription />} />
            <Route path="/auditDescription2" element={<AuditDescription2 />} />
            <Route
              path="/formDetails/:audit_id"
              element={<FormDetails />}
            />
            <Route path='/DocumentUploadScreen/:audit_id' element={<DocumentUploadScreen />} />
             {/* <Route
              path="/PrefDeathForm/:claim_id"
              element={<PrefDeathForm />}
            />
             */}
                      <Route
            path="/PrefDeathForm/:claim_id/:eartag/:mpcs/:dod"
            element={<PrefDeathForm />}
          />

            <Route
              exact
              path="/AuditDesc/:audit_id"
              element={<AuditDesc />}

            />
              <Route
              exact
              path="/AuditDeathDesc/:audit_id"
              element={<AuditDeathDesc />}
            />
            <Route path="/home" element={<Inspection />} />
            <Route
  path="/audit/hybrid/permission/:audit_id"
  element={
    <ProtectedRoute>
      <PermissionHybrid />
    </ProtectedRoute>
  }
/>

<Route
  path="/audit/hybrid/:audit_id"
  element={
    <ProtectedRoute>
      <StartInspectionHybrid />
    </ProtectedRoute>
  }
/>

<Route
  path="/audit/video/permission/:audit_id"
  element={
    <ProtectedRoute>
      <PermissionVideo />
    </ProtectedRoute>
  }
/>

<Route
  path="/audit/video/:audit_id"
  element={
    <ProtectedRoute>
      <StartInspectionVideo />
    </ProtectedRoute>
  }
/>

<Route
  path="/audit/photo/:audit_id"
  element={
    <ProtectedRoute>
      <StartInspection />
    </ProtectedRoute>
  }
/>

<Route
  path="/audit/photo/permission/:audit_id"
  element={
    <ProtectedRoute>
      <Permission />
    </ProtectedRoute>
  }
/>

<Route
  path="/audit/term_and_conditions/:method/:audit_id"
  element={
    <ProtectedRoute>
      <TermAndConditions />
    </ProtectedRoute>
  }
/>

            {/* <Route path="/view-audit" element={<ViewAudit />} /> */}
            {/* <Route
              exact
              path="/audit/inspection/mode/:audit_id"
              element={<ModeProtectedRoute element={InspectionMethod} />}
            /> */}
          <Route
  path="/audit/inspection/mode/:audit_id"
  element={
    <ModeProtectedRoute>
      <InspectionMethod />
    </ModeProtectedRoute>
  }
/>
            <Route
  path="/auditclaim/term_and_conditions/:method/:audit_id"
  element={
    <ModePrRoute>
      <TermAndConditions2 />
    </ModePrRoute>
  }
/>

<Route
  path="/formuploadfiles/:audit_id"
  element={
    <ModePrRoute>
      <FormUpload />
    </ModePrRoute>
  }
/>

<Route
  path="/audit/claim/mode/:audit_id"
  element={
    <ModePrRoute>
      <InspectionMethod2 />
    </ModePrRoute>
  }
/>

<Route
  path="/auditclaim/photo/permission/:audit_id"
  element={
    <ModePrRoute>
      <Permission2 />
    </ModePrRoute>
  }
/>

            {/* <Route
              exact
              path="/formuploadfiles/:audit_id"
              element={<ModePrRoute element={FormUpload} />}
            />

            <Route
              exact
              path="/audit/claim/mode/:audit_id"
              element={<ModePrRoute element={InspectionMethod2} />}
            /> */}
            {/*Terms and conditions  */}
            {/* <Route
              exact
              path="/audit/term_and_conditions/:method/:audit_id"
              element={<ProtectedRoute element={TermAndConditions} />}
            /> */}
            {/* <Route
              exact
              path="/auditclaim/term_and_conditions/:method/:audit_id"
              element={<ModePrRoute element={TermAndConditions2} />}
            /> */}
            {/* photo mode routes */}
            {/* <Route
              exact
              path="/audit/photo/permission/:audit_id"
              element={<ProtectedRoute element={Permission} />}
            /> */}
            {/* <Route
              exact
              path="/auditclaim/photo/permission/:audit_id"
              element={<ModePrRoute element={Permission2} />}
            /> */}
            <Route
              exact
              path="/audit/photoretake/permission/:audit_id"
              element={
                <RetakeStatusGuard>
                  <PermissionRetake />
                </RetakeStatusGuard>
              }
            /> 


            {/* <Route
              exact
              path="/audit/photo/:audit_id"
              element={<ProtectedRoute element={StartInspection} />}
            /> */}
            <Route
              path="/audit/photoretake/:audit_id"
              element={
                <RetakeStatusGuard>
                  <StartInspectionRetake />
                </RetakeStatusGuard>
              }
            />
            <Route path="/claim/camera/:audit_id" element={<CameraModule2 />} />
            <Route path="/camera/:audit_id" element={<CameraModule />} />

            {/* <Route path="/cameraretake/:audit_id" element={<CameraModuleRetake />} /> */}

            <Route
              path="/cameraretake/:audit_id"
              element={
                <RetakeStatusGuard>
                  <CameraModuleRetake />
                </RetakeStatusGuard>
              }
            />

            {/* video mode routes */}
            {/* <Route
              exact
              path="/audit/video/permission/:audit_id"
              element={<ProtectedRoute element={PermissionVideo} />}
            />
            <Route
              exact
              path="/audit/video/:audit_id"
              element={<ProtectedRoute element={StartInspectionVideo} />}
            /> */}
            <Route
              path="/video_intructions/:audit_id"
              element={<VideoInstruction />}
            />
            <Route path="/video/:audit_id" element={<VideoRecorder />} />
            <Route path="/videoTimer" element={<VideoTimer number={3} />} />
            <Route
              path="/processing/video/:audit_id"
              element={<ProcessingVideo />}
            />

            {/* hybrid mode route */}
            {/* <Route
              exact
              path="/audit/hybrid/permission/:audit_id"
              element={<ProtectedRoute element={PermissionHybrid} />}
            />
            <Route
              exact
              path="/audit/hybrid/:audit_id"
              element={<ProtectedRoute element={StartInspectionHybrid} />}
            /> */}
            <Route path="/camera-hybrid/:audit_id" element={<CameraModuleHybrid />} />
            <Route
              path="/processing/hybrid/:audit_id"
              element={<ProcessingHybrid />}
            />
            {/* report generation route */}
            <Route path="/auditInfo/:audit_id" element={<DownloadPdf />} />

            {/* generic route to create new audit*/}
            <Route
              exact
              path="/audit/inspection/:audit_id"
              element={<AuditCreation />}
            />
            <Route
              exact
              path="/forgot-password"
              element={<ForgotPassword />}
            />

            <Route
              exact
              path="/reset-password"
              element={<ResetPassword />}
            />
            <Route
              exact
              path="/Set-NewPassword"
              element={<PasswordResetForm />}
            />
            {/* <Route path="/nextcamera/:audit_id" element={<NextCameraModule />} /> */}
            {/* <Route
  
    path="/next-camera/:audit_id"
    element={<NextCameraModule />}
  />  */}
            {/* <Route path="/nextcamera/:audit_id" element={<NextCameraModule />} /> */}
            <Route path="/nextcamera/:audit_id" element={<NextCameraModule />} />

            <Route
              path="/NextAuditInspection/:audit_id"
              element={<NextAudit />}
            />
            {/* Generic Routes */}

            <Route path="/no-access" element={<NoAccess />} />
            {/* audit completion route */}
            <Route path="/processing/:audit_id" element={<Processing />} />
            {/* <Route path="/processingretake/:audit_id" element={<ProcessingRetake />} /> */}

            <Route
              path="/processingretake/:audit_id"
              element={
                <RetakeStatusGuard>
                  <ProcessingRetake />
                </RetakeStatusGuard>
              }
            />
            <Route path="/success" element={<SuccessComponent />} />
            <Route path="/successful/:audit_id" element={<SuccessfulComponent />} />

            {/* test routes */}
            <Route exact path="/testing" element={<DynamicResolutionWebcam />} />
            {/* <Route path="/test" element={<ShareOptions url ="https://insurance-inspection.cainatics.in/"/>} /> */}
            {/* <Route path="/test" element={<MyComponent/>} /> */}
            <Route path="/test1" element={<AuditCreation />} />
            <Route path="/test2" element={<WebcamCapture />} />

          </Routes>
        </FileProvider>
      </FullscreenProvider>
    </Router>
  );
}

export default App;